export default "__VITE_ASSET__CqVK8IGx__"